<template>
  <div class="accounting-document-amount-header" style="width: 100%">
    <div>{{ params.displayName }}</div>
    <div class="unit">
      <span>{{ $t('FinanceManage.Billion') }}</span>
      <span>{{ $t('FinanceManage.Thousand') }}</span>
      <span class="blue">{{ $t('FinanceManage.Hundred') }}</span>
      <span>{{ $t('FinanceManage.Ten') }}</span>
      <span>{{ $t('FinanceManage.TenThousand') }}</span>
      <span>{{ $t('FinanceManage.Thousand') }}</span>
      <span class="blue">{{ $t('FinanceManage.Hundred') }}</span>
      <span>{{ $t('FinanceManage.Ten') }}</span>
      <span class="pink">{{ $t('FinanceManage.Yuan') }}</span>
      <span>{{ $t('FinanceManage.Dime') }}</span>
      <span>{{ $t('FinanceManage.Cent') }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'AccountingDocumentAmountHeader'
})
</script>

<style lang="scss">
.accounting-document-amount-header{
  .unit{
    display: flex;
    justify-content: space-between;
    span{
      flex: 1;
      border-right: 1px solid #e6e6e6;
      &.blue{
        border-color:#a7d9f5;
      }
      &.pink{
        border-color:#eebbbb;
      }
      &:nth-last-child(1){
        border:none
      }
    }
  }
}

</style>
